import { RouteObject } from "react-router-dom";
import { TabPanel } from "@mui/lab";
import DatasetPageLayout from "datasets/components/DatasetPageLayout";
import DatasetTableList from "datasets/pages/tables/components/DatasetTableList";
import AddTable from "datasets/pages/tables/pages/AddTable";
import DatasetTable from "datasets/pages/tables/pages/DatasetTable";
import { ProtectedAppRoute } from "~/components/ProtectedAppRoute";
import { useSafeRoutes } from "~/hooks/useSafeRoutes";

const routeDefinitions: RouteObject[] = [
  { index: true, element: <DatasetTableList /> },
  { path: ":tableFQN", element: <DatasetTable /> },
  {
    path: "new",
    element: (
      <ProtectedAppRoute permission="create:catalog-ingest">
        <AddTable />
      </ProtectedAppRoute>
    ),
  },
];

const DatasetTables = () => {
  const routes = useSafeRoutes(routeDefinitions);

  return (
    <TabPanel value="tables" sx={{ p: 0 }}>
      <DatasetPageLayout>{routes}</DatasetPageLayout>
    </TabPanel>
  );
};

export default DatasetTables;
